<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><a id="page_iii">Contents</a></p><a id="page_iii">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td align="left" valign="top"><p class="toc"></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/06_Introductory">Introductory</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a href="#/xhtml/07_Chapter01">I</a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/07_Chapter01">The Cocktail Party</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a href="#/xhtml/08_Chapter02">II</a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/08_Chapter02">Hors-d’œuvre, First-course Dishes, and After-dinner Savouries</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a href="#/xhtml/09_Chapter03">III</a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/09_Chapter03">Kitchen Knowledge</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/09_Chapter03#h1.1">Tables of Weights and Measures</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a href="#/xhtml/10_Chapter04">IV</a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/10_Chapter04">Kitchen Processes</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a href="#/xhtml/11_Chapter05">V</a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/11_Chapter05">Soups and Soup-making</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">VI</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">Sauces</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">VII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">Root Vegetables</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">VIII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">Green Vegetables</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">IX</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">Vegetables: Flowers and Fruits</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">X</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">Vegetable Entrées, Dressed Vegetables, and Simple Luncheon Dishes</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">XI</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">Eggs and Savoury Soufflés</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample">XII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample">Salads</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/19_Chapter13" title="Link target outside of Sample">XIII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/19_Chapter13" title="Link target outside of Sample">Herbs</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/20_Chapter14" title="Link target outside of Sample">XIV</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/20_Chapter14" title="Link target outside of Sample">Rice, Risottos, Pilaffs, and Curries</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/21_Chapter15" title="Link target outside of Sample">XV</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/21_Chapter15" title="Link target outside of Sample">Pastas, Pasta Dishes, and Batters</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/22_Chapter16" title="Link target outside of Sample">XVI</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/22_Chapter16" title="Link target outside of Sample">Fish</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/23_Chapter17" title="Link target outside of Sample">XVII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/23_Chapter17" title="Link target outside of Sample">Meat – Beef, Mutton and Lamb, Pork, Veal</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/24_Chapter18" title="Link target outside of Sample">XVIII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/24_Chapter18" title="Link target outside of Sample">Meat – Les Abats</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/25_Chapter19" title="Link target outside of Sample">XIX</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/25_Chapter19" title="Link target outside of Sample">Pièces Froides</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/26_Chapter20" title="Link target outside of Sample">XX</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/26_Chapter20" title="Link target outside of Sample">Poultry and Game</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/27_Chapter21" title="Link target outside of Sample">XXI</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/27_Chapter21" title="Link target outside of Sample">Force-meats, Farces, Stuffings, etc.</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/28_Chapter22" title="Link target outside of Sample">XXII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/28_Chapter22" title="Link target outside of Sample">Réchauffés</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/29_Chapter23" title="Link target outside of Sample">XXIII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/29_Chapter23" title="Link target outside of Sample">Devils, Barbecues, and Marinades</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/30_Chapter24" title="Link target outside of Sample">XXIV</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/30_Chapter24" title="Link target outside of Sample">Cold Savoury Mousses, Soufflés, and Aspic</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/31_Chapter25" title="Link target outside of Sample">XXV</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/31_Chapter25" title="Link target outside of Sample">Milk and Cheese</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/32_Chapter26" title="Link target outside of Sample">XXVI</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/32_Chapter26" title="Link target outside of Sample">Bread and Bread-making</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/33_Chapter27" title="Link target outside of Sample">XXVII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/33_Chapter27" title="Link target outside of Sample">Cakes</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/34_Chapter28" title="Link target outside of Sample">XXVIII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/34_Chapter28" title="Link target outside of Sample">Pastry</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/35_Chapter29" title="Link target outside of Sample">XXIX</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/35_Chapter29" title="Link target outside of Sample">Pâtisserie, Petits Fours, Petits Gâteaux, and Gros Gâteaux</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/36_Chapter30" title="Link target outside of Sample">XXX</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/36_Chapter30" title="Link target outside of Sample">Sweets, Hot and Cold</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/37_Chapter31" title="Link target outside of Sample">XXXI</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/37_Chapter31" title="Link target outside of Sample">Winkfield</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/38_Chapter32" title="Link target outside of Sample">XXXII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/38_Chapter32" title="Link target outside of Sample">Breakfast and Tea</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/39_Chapter33" title="Link target outside of Sample">XXXIII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/39_Chapter33" title="Link target outside of Sample">Garniture and Presentation of Food</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/40_Chapter34" title="Link target outside of Sample">XXXIV</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/40_Chapter34" title="Link target outside of Sample">Menus, Parties, and Food for Special Occasions</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/41_Chapter35" title="Link target outside of Sample">XXXV</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/41_Chapter35" title="Link target outside of Sample">The Store Cupboard</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/42_Chapter36" title="Link target outside of Sample">XXXVI</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/42_Chapter36" title="Link target outside of Sample">The Kitchen</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/43_Chapter37" title="Link target outside of Sample">XXXVII</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/43_Chapter37" title="Link target outside of Sample">Modern Kitchen Appliances</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/44_Appendix" title="Link target outside of Sample">Appendix: Wines, their Choice and Serving</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/45_Index" title="Link target outside of Sample">Index</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/46_Back" title="Link target outside of Sample">International Conversion Tables</span></p></td>
</tr>
</tbody>
</table>
</a></div><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?560f1fc8